export const APP_STORE_URL = "https://apps.apple.com/app/id6806280244";
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=app.samklang.mobile";

export type MobileStore = "app_store" | "google_play";

export function preferredMobileStore(userAgent: string): MobileStore | null {
  const normalized = userAgent.toLocaleLowerCase("en-US");
  if (/iphone|ipad|ipod/.test(normalized)) return "app_store";
  if (/android/.test(normalized)) return "google_play";
  return null;
}
